export default {
    getAllSiteContents (state) {
        return state.allContents
    },
    getUnauthContents (state) {
        return state.unauthPageContents
    },
    getAllNewsResources (state) {
        return state.newsResources
    },
    getAllFeaturedArticles (state) {
        return state.faResources
    },
    getAllSetToneResources (state) {
        return state.stResources
    },
    getAllAdvertisementResources (state) {
        return state.abResources
    }

}



// WEBPACK FOOTER //
// ./src/store/dynamiccontents/getters.js